import React, { useState, useEffect, useContext } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axiosHttp from "../config/axios.interceptor";
import Loader from "../components/Loader";
import UpcomingSingleSession from "../components/UpcomingSingleSession";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import undrawProfile from "../img/undraw_profile.svg";
import { errorResponseMessage } from "../shared/const.prop";

const UpcomingSession = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [slotList, setSlotList] = useState();
  const location = useLocation();
  const { serviceName = "" } = location.state;
  // const [page, setPage] = useState(1);
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const navigate = useNavigate();
  const [hello, setHello] = useState(id);
  const userId = user?.userId || user?.data?.data?.userId;
  const userName = user?.userName || user?.data?.data?.userName;

  useEffect(() => {
    if (
      appContext.openModal === false &&
      appContext.pendingAction?.name === "rescheduleSession"
    ) {
      setLoading(true);
      let { appId, serviceName } = appContext.pendingAction;
      fetchWeeklySchedule(serviceName, appId);
    } else if (appContext.openModal === false) {
      setLoading(true);
      fetchWeeklySchedule(serviceName, id);
    }
  }, [appContext.openModal]);

  useEffect(() => {
    setLoading(true);
    fetchWeeklySchedule(serviceName, id);
  }, [id]);

  const fetchWeeklySchedule = async (serviceName, id) => {
    if (serviceName === "Single session") {
      try {
        const getSchedule = await axiosHttp.get(`appointments/${id}/single`);
        if (getSchedule.status === 200) {
          let data = getSchedule?.data?.data;
          setSlotList(data);
          setLoading(false);
        }
      } catch (e) {
        if (e.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(e),
            type: "error",
          });
          authContext.logout();
        }
        if (e.response.status === 400) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(e),
            type: "error",
          });
        }
        if (e.response?.status >= 500) {
          appContext.updateNotificationState({
            show: true,
            message: "Something went wrong, please try again later.",
            type: "error",
          });
        }
        //console.log(e);
        setLoading(false);
      }
    } else {
      try {
        const getScheduleList = await axiosHttp.get(
          `appointments/${id}/weekly`
        );
        if (getScheduleList.status === 200) {
          let data = getScheduleList?.data?.data;
          setSlotList(data);
          setLoading(false);
        }
      } catch (e) {
        if (e.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(e),
            type: "error",
          });
          authContext.logout();
        }
        if (e.response.status === 400) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(e),
            type: "error",
          });
        }
        if (e.response.status === 422) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(e),
            type: "error",
          });

          navigate("../myspace/schedule");
        }
        if (e.response?.status >= 500) {
          appContext.updateNotificationState({
            show: true,
            message: "Something went wrong, please try again later.",
            type: "error",
          });
        }
        //console.log(e);
        setLoading(false);
      }
    }
  };

  const cancellationHandler = (schedule) => {
    appContext.updateModalType("cancelSession", "Cancellation", {
      ...schedule,
      // id: id,
      service_name: "weekly sessions",
    });
  };

  const rescheduleHandler = (schedule) => {
    appContext.updateModalType("rescheduleSession", "", {
      ...schedule,
      // id: id,
      appointment_id: id,
      // service_name: "weekly sessions",
    });
  };

  const rescheduleSingleHandler = (schedule) => {
    appContext.updateModalType("rescheduleSession", "", schedule);
  };

  const cancellationSingleHandler = (schedule) => {
    appContext.updateModalType("cancelSession", "Cancellation", schedule);
  };

  // const renderProfileImage = () => {
  // if(serviceName === "Single session") {
  //   if(user?.userId && user?.userId ===  slotList?.mentor_id){

  //   }
  // }}

  // src={
  //   user?.userId && user?.userId === item?.mentor_id
  //     ? item?.mentee_pic_url || undrawProfile
  //     : user?.data?.data?.userId === item?.mentor_id
  //     ? item?.mentee_pic_url || undrawProfile
  //     : item?.mentor_pic_url || undrawProfile
  // }

  const isSMEProfile = () => {
    if (serviceName === "Single session") {
      if (userId === slotList?.mentor_id) {
        return slotList?.mentee_offer_service || false;
      } else {
        return slotList?.mentor_offer_service || false;
      }
    } else {
      if (userId === slotList[0]?.mentor_id) {
        return slotList[0]?.mentee_offer_service || false;
      } else {
        return slotList[0]?.mentor_offer_service || false;
      }
    }
  };

  const profileRedirectHandler = () => {
    if (serviceName === "Single session") {
      if (userName === slotList?.mentor_name) {
        navigate(`../${slotList?.mentee_user_name}`);
      } else {
        navigate(`../${slotList?.mentor_user_name}`);
      }
    } else {
      if (userName === slotList[0]?.mentor_name) {
        navigate(`../${slotList[0]?.mentee_user_name}`);
      } else {
        navigate(`../${slotList[0]?.mentor_user_name}`);
      }
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="card card-one-1 mb-5">
      <div className="card-body">
        <div className="row">
          <div className="col-md-5">
            <div
              className="d-flex chat-name s-name"
              onClick={profileRedirectHandler}
            >
              <div className="sme-profile">
                <img
                  className={`img-profile rounded-circle ${
                    isSMEProfile() ? "sme-mini-service" : null
                  }`}
                  src={
                    serviceName === "Single session"
                      ? slotList?.mentor_id === localStorage.getItem("userId")
                        ? slotList?.mentee_pic_url
                        : slotList?.mentee_id === localStorage.getItem("userId")
                        ? slotList?.mentor_pic_url
                        : undrawProfile
                      : slotList[0]?.mentor_id ===
                        localStorage.getItem("userId")
                      ? slotList[0]?.mentee_pic_url || undrawProfile
                      : slotList[0]?.mentee_id ===
                        localStorage.getItem("userId")
                      ? slotList[0]?.mentor_pic_url || undrawProfile
                      : undrawProfile
                  }
                  // src={renderProfileImage()}
                />
                {isSMEProfile() && <div className="sme-mini-icon">SME</div>}
              </div>
              <p className="profile-name mb-0 ml-3 mt-2">
                <b>
                  {/* {serviceName === "Single session"
                    ? slotList.mentor_name || "User"
                    : slotList[0].mentorName || "User"} */}
                  {serviceName === "Single session"
                    ? slotList.mentor_id === localStorage.getItem("userId")
                      ? slotList.mentee_name
                      : slotList.mentee_id === localStorage.getItem("userId")
                      ? slotList.mentor_name
                      : "User"
                    : slotList[0]?.mentor_id === localStorage.getItem("userId")
                    ? slotList[0].mentee_name
                    : slotList[0].mentee_id === localStorage.getItem("userId")
                    ? slotList[0]?.mentor_name
                    : "User"}
                </b>
              </p>
            </div>
          </div>
          <div className="col-md-4 ">
            <p className="chat-p text-dark mt-2">
              {serviceName === "Single session"
                ? "Single session"
                : slotList[0].service_name || "weekly sessions"}
            </p>
          </div>
        </div>
        <hr />
        <p className="up-p">Upcoming Session</p>
        {serviceName !== "Single session" && slotList.length === 0 && (
          <p>No slots available</p>
        )}
        {serviceName !== "Single session" &&
          slotList.length > 0 &&
          slotList.map((item) => {
            return (
              <UpcomingSingleSession
                item={item}
                cancellationHandler={cancellationHandler}
                rescheduleHandler={rescheduleHandler}
              />
            );
          })}
        {serviceName === "Single session" && (
          <UpcomingSingleSession
            item={slotList}
            cancellationHandler={cancellationSingleHandler}
            rescheduleHandler={rescheduleSingleHandler}
          />
        )}
        {/* <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <button
              class="btn btn-primary prime-btn px-3"
              onClick={() => setPage(page + 1)}
            >
              Load More
            </button>
          </div>
          <div class="col-md-4"></div>
        </div> */}
      </div>
    </div>
  );
};

export default UpcomingSession;
